import axios from 'axios';
import { handleUnauthorized } from 'utils/session';

const baseIBGE = 'https://servicodados.ibge.gov.br/api/v1/localidades/';
const baseVIACEP = 'https://viacep.com.br/ws/';
const { REACT_APP_BASE_URL } = process.env;

const app = axios.create({
  baseURL: REACT_APP_BASE_URL,
});

app.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

app.interceptors.response.use(
  (response) => response,
  (error) => handleUnauthorized(error)
);

const auth = axios.create({
  baseURL: REACT_APP_BASE_URL,
});

auth.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

auth.interceptors.response.use(
  (response) => response,
  (error) => handleUnauthorized(error)
);

const ibge = axios.create({
  baseURL: baseIBGE,
});

const viacep = axios.create({
  baseURL: baseVIACEP,
});

export { auth, app, ibge, viacep };
